import styled from 'styled-components';

import { Value } from '../EditableTextInput/styles';

export const EmptyValue = styled(Value)`
  color: ${({ theme }) => theme.palette.common.black};
  opacity: 0.38;
`;
